import {ngAsync} from 'shared/utils/ng-@decorators';
import {unRestangularize} from 'shared/utils/data-service-utils';
import type {Field007Definitions, Field008Definitions} from 'typings/portaro.be.types';


export class FieldsDefinitionsDataService {
    public static serviceName = 'fieldsDefinitionsDataService'

    private static readonly FIELDS_DEFINITIONS_ROUTE = 'fields-definitions';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public async getField007Definitions(): Promise<Field007Definitions> {
        return this.Restangular
            .one(`${FieldsDefinitionsDataService.FIELDS_DEFINITIONS_ROUTE}/007`)
            .get();
    }

    @ngAsync()
    @unRestangularize()
    public async getField008Definitions(): Promise<Field008Definitions> {
        return this.Restangular
            .one(`${FieldsDefinitionsDataService.FIELDS_DEFINITIONS_ROUTE}/008`)
            .get();
    }
}